/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { legacyPlanReportPageRedirectRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/legacyPlanReportPageRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import RedirectLegacyReportPage from './common/ui/redirect/report/index.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';

export const legacyPlanReportPageRedirectRouteEntry: Route = createEntry(
	legacyPlanReportPageRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectLegacyReportPage,
		isRedirect: true,
		layout: globalLayout,
		resources: [...getNavigationResources()],

		navigation: {
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
